<template>
  <div>
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="6">
            <v-select
              v-model="user.supplierId"
              :items="itemsSupplier"
              item-value="supplierId"
              item-text="supplierName"
              label="SupplierId"
            ></v-select>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import api from "../../../../api";
export default {
  props: {
    user: {
      type: Object,
    },
  },
  name: "SupplierTab",
  data() {
    return {
      itemsSupplier: [],
      roleItems: [],
      itemsRole: [{ text: "Supplier", value: 2 }],
    };
  },
  mounted() {
    this.getAllSupliers();
  },
  methods: {
    async getAllSupliers() {
      this.itemsSupplier = await api.suppliers.getAll();
    },
    async getAllRoles() {
      this.roleItems = await api.roles.getAll();
    },
  },
};
</script>
